import React from "react";

/**
 * Red de seguridad: si algún componente lanza durante el render (p.ej. datos publicados inesperados),
 * muestra un mensaje en lugar de dejar TODO el sitio en blanco (React desmonta el árbol ante un throw
 * de render no capturado).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Error de render en la landing:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full flex flex-col items-center justify-center py-20 text-center footerAdjust">
          <h1 className="text-2xl mb-3">
            <strong>Algo salió mal</strong>
          </h1>
          <p className="text-gray-600">Por favor recarga la página.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
